"use client";

import React from "react";

import { SectionTitle } from "./section-title";
import { SkeletonBox } from "./skeleton-box";

export const StudentPanelSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 px-3 py-4">
      {/* Basic Info — 4 rows 16px each, padding so total 50 (4×12 + 2) */}
      <div>
        <SectionTitle title="Basic Info" />
        <div className="mt-2 flex flex-col gap-3 space-y-0 py-1">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="flex h-4 gap-2"
            >
              <SkeletonBox className="h-4 w-24 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>

      {/* Enrollment & Zoning — 6 rows */}
      <div>
        <SectionTitle title="Enrollment & Zoning" />
        <div className="mt-2 flex flex-col gap-3 space-y-0 py-1">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div
              key={i}
              className="flex gap-2"
            >
              <SkeletonBox className="h-4 w-28 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>

      {/* Race & Ethnicity — one badge skeleton, same layout as real section */}
      <div>
        <SectionTitle title="Race & Ethnicity" />
        <div className="mt-2 flex flex-wrap gap-2">
          <SkeletonBox className="h-6 min-w-[4rem] rounded-full px-3 py-1" />
        </div>
      </div>

      {/* Other Info — one badge skeleton */}
      <div>
        <SectionTitle title="Other Info" />
        <div className="mt-2 flex flex-wrap gap-2">
          <SkeletonBox className="h-6 min-w-[4rem] rounded-full px-3 py-1" />
        </div>
      </div>
    </div>
  );
};
